/**
 * The translation key for an API error code.
 *
 * The server sends a stable machine code and never a sentence, so every failure
 * is translated here. Codes contain dots, which vue-i18n would otherwise read
 * as a path into nested objects - hence the bracket form, and hence the flat
 * `errors` map keyed by the literal code.
 *
 * Its own module rather than `index.ts` so that {@link useAsyncAction} can
 * import it without the two files importing each other.
 */
export function errorMessageKey(code) {
    return `errors['${code}']`;
}
//# sourceMappingURL=errors.js.map